export const fnOrUndef = (condition, fn) => (condition ? fn : undefined);

export const debounce = (fn, delay = 1000) => {
  const timeoutId = setTimeout(fn, delay);
  return () => clearTimeout(timeoutId);
};
